/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";
import { MarkdownReader } from "@/components/dataDisplay/MarkdownReader";
import ImageViewer from "./ImageViewer";
import { styles } from "./styles";

interface Props {
  content?: string;
  src?: string;
}

export const Image: React.FC<Props> = ({ content, src }) => {
  return (
    <div style={styles.contentContainer}>
      {content && <MarkdownReader>{content}</MarkdownReader>}
      <ImageViewer src={src} />
    </div>
  );
};
